import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceGSuite = (props) => {

    const CrmServerTokenController = "/api/gsuite/tokens"
    const ClientId = "1060468872468-8evhscaekclf4anai33tmu33kutoh3nc.apps.googleusercontent.com"
    const Scope = "https://www.googleapis.com/auth/contacts.readonly"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://accounts.google.com/o/oauth2/v2/auth?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&access_type=offline&prompt=consent&redirect_uri=" + RedirectUrl

    props.IntegrationSettings.DatasourceSettings.DatasourceVersion = "2"

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController={CrmServerTokenController} OnSetReady={props.OnSetReady}/>
}

DatasourceGSuite.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceGSuite